<template>
  <div class="top_navbar_container">
    <div class="navbar_desc">
      <!-- <button
        type="button"
        class="navbar-toggler top_burger-btn navbar-toggler-right"
        
        aria-controls="navigation-index"
        aria-expanded="false"
        aria-label="Toggle navigation"
        @click="toggleSidebar"
      >
        <div id="burger">
          <span id="burger" class="navbar-toggler-bar top_burger burger-lines"></span>
          <span id="burger" class="navbar-toggler-bar top_burger burger-lines"></span>
          <span id="burger" class="navbar-toggler-bar top_burger burger-lines"></span>
        </div>
      </button> -->

      <button
        id="burger"
        type="button"
        class="burger-button"
        @click="toggleSidebar"
      >
        <svg id="burger" class="burger-icon">
          <use id="burger" href="../assets/icons/menu.svg#menu"></use>
        </svg>
      </button>

      <div class="navbar_lists">
        <div
          v-if="userWidgets?.length > 0"
          class="navbar_desc_btn"
        >
          <p class="navbar_text">
            <span class="messages_long">Messages remaining:</span>
            <span class="messages_short">Msgs:</span> {{ !isSubscriptionActive ? freeMessagesLeft : subscriptionData?.messages_available }}
          </p>

          <ButtonWithLoadWebsite
            v-if="!isSubscriptionActive"
            title="Upgrade"
            @onClick="handleUpgradeClick"
            :shaked="freeMessagesLeft === 0"
          />
        </div>
        <sidebar-link
          v-if="!userWidgets || userWidgets?.length < 3"
          class="navbar_lists_text"
          :class="{ active: $route.path === '/user/chatbots' }"
          to="/user/chatbots"
        >
          Chatbots
        </sidebar-link>
        <sidebar-link
          class="navbar_lists_text"
          :class="{ active: $route.path === '/user/billing' }"
          to="/user/billing"
        >
          Billing
        </sidebar-link>
      </div>

      <div class="navbar_email">
        <div class="navbar_content_email">
          <!-- <span class="navbar_content_name"> {{ user?.name }} </span> -->
          <!-- <span class="navbar_content_email_text">
            {{ email }}
          </span> -->
        </div>
        <div class="navbar_img_cont">
          <div @click="asdasd">
            <span class="navbar_content_name email navbar_img_"> {{ user?.email }} </span>
          </div>
          <!-- <div class="navbar_img" @click="asdasd">
            <img
              src="@/assets/img/Rectangle 4963.svg"
              alt="Creative Tim Logo"
              class="navbar_img_"
            />
          </div> -->
          <!-- <div v-click-outside="closeTooltip" class="log_out_cont" v-if="showTooltip" @click="logOut">
            <img src="@/assets/img/log_out.svg" alt="" />
            <span class="log_out">Log out</span>
          </div> -->
          <div
            v-click-outside="closeTooltip"
            class="log_out_cont"
            :class="{ log_out_open: showTooltip }"
            @click="logOut"
          >
            <div class="log_out_corner"></div>
            <span class="log_out">Log out</span>
          </div>
        </div>
      </div>
    </div>

    <Modal :isModalOpen="billingModalShown" @close="billingModalShown = false" :width="1200">
      <div slot="body" class="modal_body">
        <BillingForm type="modal" />
      </div>
    </Modal>
  </div>
</template>
<script>
import vClickOutside from "v-click-outside";
import ButtonWithLoadWebsite from "../components/shared/ButtonWithLoadWebsite.vue";
import Modal from "../components/shared/Modal/Modal.vue";
import BillingForm from "../pages/Billing/BillingForm.vue";
import store from "../vuex/store";
const MAX_FREE_MESSAGES_COUNT = 10;

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  components: {
    ButtonWithLoadWebsite,
    Modal,
    BillingForm,
  },
  data() {
    return {
      // user: {
      //   email: "",
      //   password: "",
      //   newPassword: "",
      // },
      activeNotifications: false,
      showTooltip: false,
      billingModalShown: false,
    };
  },
  props: {
    toggleSidebar: Function,
    setChosenNull: Function,
  },
  computed: {
    subscriptionData() {
      return store?.state?.users?.chosenWidget?.owner?.subscription;
    },
    isSubscriptionActive() {
      const subscription = store?.state?.users?.chosenWidget?.owner?.subscription;
      const isActiveSubscription =
        subscription?.status === "trialing" ||
        subscription?.status === "active";

      return subscription && isActiveSubscription;
    },
    userWidgets() {
      return store?.state?.users?.widgets;
    },
    user() {
      return store?.state?.auth?.user;
    },
    disabledBtn() {
      return !this.$route.path.includes("create_bot");
    },
    isLoading() {
      return store?.state?.auth?.isLoading;
    },
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    email() {
      return (this.user.email = store?.getters?.getEmail);
    },
    totalMessagesCount() {
      return store?.getters?.getTotalMessagesCount || 0;
    },
    freeMessagesLeft() {
      const noFreeMessagesLeft =
        this.totalMessagesCount > MAX_FREE_MESSAGES_COUNT;

      return noFreeMessagesLeft
        ? 0
        : MAX_FREE_MESSAGES_COUNT - this.totalMessagesCount;
    },
  },
  methods: {
    asdasd() {
      this.showTooltip = !this.showTooltip;
    },
    closeTooltip(e) {
      if (e.target.classList.contains("navbar_img_")) {
        return;
      }

      this.showTooltip = false;
      // console.log(this.showTooltip)
    },
    logOut() {
      store.dispatch("startLoading");
      store.dispatch("logout");
      store.dispatch("endLoading");
    },
    capitalizeFirstLetter(string) {
      return string?.charAt(0)?.toUpperCase() + string?.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    // toggleSidebar() {
    //   this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    // },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    subPlan() {
      // this.$router.push("/user/subscription");
    },
    handleUpgradeClick() {
      this.billingModalShown = true;
      // this.$router.push({ path: "/user/subscription" });
    },
  },
};
</script>

<style scoped lang="scss">
.nav-link {
  cursor: pointer;
}
.top_navbar_container {
  /* height: 79px; */
  min-height: 51px;
  background: #fff;
  padding: 8px 21px 8px 34px;
  border-bottom: 1px solid #e3e8ef;

  @media screen and (max-width: 1279px) {
    width: 100vw;
  }
}
.navbar_desc {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.navbar_text {
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  color: #637381;

  &.messagesShown {
    display: none;

    @media (min-width: 1480px) {
      display: inline;
    }
  }
}

.messages_long {
  @media (max-width: 499px) {
    display: none;
  }
}

.messages_short {
  @media (min-width: 500px) {
    display: none;
  }
}
.navbar_desc_btn {
  display: flex;
  align-items: center;
  /* flex-direction: column; */
  gap: 17px;

  /* @media screen and (max-width: 1279px) {
    display: none;
  } */
}

.navbar_content_email {
  display: flex;
  flex-direction: column;

  @media (max-width: 900px) {
    display: none;
  }
}
.navbar_email {
  /* display: none; */
  display: flex;
  align-items: center;
  gap: 15px;
}
.navbar_content_name {
  color: #637381;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  text-align: end;
  cursor: pointer;

  &.email {
    font-size: 14px;
  }

  @media (max-width: 589px) {
    display: none;
  }
}
.navbar_content_email_text {
  color: #637381;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.navbar_lists {
  display: flex;
  flex-grow: 1;
  margin-left: 10px;
  width: 100%;
  gap: 5%;
  /* min-width: 450px;
  max-width: 100%; */
  /* padding: 0 48px; */
  @media (min-width: 1480px) {
    margin-left: 0;
  }

  @media (max-width: 499px) {
    justify-content: center;
  }
}
.navbar_lists_text {
  color: #637381;
  background: none;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  transition: all 150ms linear;

  &:hover:not(.active),
  :focus-visible:not(.active) {
    color: #3056d3;
  }

  @media (max-width: 599px) {
    display: none;
  }
}
.navbar_img {
  width: 49px;
  cursor: pointer;
  height: 49px;
  border-radius: 40px;
  overflow: hidden;
}
.navbar_lists_text.active {
  color: #3056d3;
}
.navbar_img_ {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.navbar_img_cont {
  position: relative;
}
.log_out_cont {
  width: 100px;
  text-align: center;
  position: absolute;
  z-index: 10;
  right: 0%;
  bottom: -200%;
  padding-top: 3px;
  padding: 10px;
  background-color: #fff;
  border: 1px solid #e3e8ef;
  border-radius: 3px;
  cursor: pointer;
  transform: translate(0, -50%) scale(0);
  transition: all 150ms linear;

  &.log_out_open {
    transform: translate(0, 0) scale(1);
  }
}

.log_out_corner {
  position: absolute;
  top: -5px;
  right: 28%;
  width: 10px;
  height: 10px;
  transform: rotate(45deg);
  border-top: 1px solid #e3e8ef;
  border-left: 1px solid #e3e8ef;
  background-color: #fff;
}
.log_out {
  display: inline-block;
  color: #f00;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.top_burger {
  display: block;
  position: relative;
  background-color: #888;
  width: 24px;
  height: 2px;
  border-radius: 1px;
  margin: 4px auto;
}

.burger-button {
  background: transparent;
  padding: 5px;
  border: none;
  outline: none;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    & > svg {
      fill: #3056d3;
    }
  }

  @media (min-width: 1480px) {
    display: none;
  }
}

.burger-icon {
  width: 24px;
  height: 24px;
  fill: #4f4f4f;
  transition: all 150ms linear;
}

.linkBtn {
  background: transparent;
  border: 1px solid #3056d3;
  border-radius: 6px;
  font-family: inherit;
  color: #3056d3;
  padding: 4px 8px;
  transition: all 150ms linear;

  &:hover,
  &:focus-visible {
    background-color: #3056d3;
    color: white;
  }
}

@media screen and (min-width: 1480px) {
  .navbar_email {
  }
  .top_burger-btn {
    display: none;
  }
}

@media screen and (max-width: 1480px) {
  .navbar_desc {
    /* flex-direction: row-reverse; */
  }
  .navbar_container {
    padding: 20px;
  }
}

.modal_body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  max-width: 1200px;
}

:deep(.modal__box) {
  max-width: 1200px !important;
}
</style>
